export default __webpack_public_path__ + "static/media/puzzleClue2.83450bb0.png";